import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Youtube24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      d="M12.9 6c1.261.009 5.137.059 6.242.357a2.138 2.138 0 011.503 1.516c.317 1.194.351 3.545.355 4.036v.132c-.001.35-.025 2.844-.355 4.085a2.138 2.138 0 01-1.503 1.516c-1.252.338-6.064.357-6.594.358h-.096c-.53-.001-5.342-.02-6.594-.358a2.138 2.138 0 01-1.503-1.516c-.305-1.146-.348-3.36-.354-3.968v-.317c.006-.609.05-2.822.354-3.968a2.138 2.138 0 011.503-1.516c1.105-.298 4.98-.348 6.242-.356zm-2.375 3.324v5.144l4.417-2.572-4.417-2.572z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export default Youtube24;
